const LEAGUE_GROUPS = ["Baseball", "Basketball", "Football", "Hockey"];

export const LeagueFilterBar = ({ leagues, active, onChange }) => {
  const grouped = LEAGUE_GROUPS.map((group) => ({ group, items: leagues.filter((l) => l.group === group) }));

  return (
    <div data-testid="line-movement-league-filters" className="flex flex-wrap items-center gap-2">
      <button
        type="button"
        data-testid="line-movement-league-all"
        onClick={() => onChange("ALL")}
        className={`rounded-full border px-3 py-1.5 font-mono text-xs uppercase tracking-wide transition-colors ${
          active === "ALL" ? "border-eb-accent bg-eb-accent/10 text-eb-accent" : "border-white/10 text-zinc-400 hover:text-zinc-200"
        }`}
      >
        All
      </button>
      {grouped.map(({ group, items }) =>
        items.map((l) => (
          <button
            key={l.league}
            type="button"
            data-testid={`line-movement-league-${l.league.toLowerCase()}`}
            disabled={!l.available}
            title={l.available ? group : "Unavailable -- The Odds API has no confirmed market for this league yet"}
            onClick={() => l.available && onChange(l.league)}
            className={`rounded-full border px-3 py-1.5 font-mono text-xs uppercase tracking-wide transition-colors ${
              !l.available
                ? "cursor-not-allowed border-white/5 text-zinc-600"
                : active === l.league
                ? "border-eb-accent bg-eb-accent/10 text-eb-accent"
                : "border-white/10 text-zinc-400 hover:text-zinc-200"
            }`}
          >
            {l.label}
            {!l.available && <span className="ml-1 text-[9px] text-zinc-600">N/A</span>}
          </button>
        ))
      )}
    </div>
  );
};
